import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {TemplateApiService} from "./template-api.service";
import {TemplateService} from "./template.service";

@NgModule({
    imports: [
        SharedModule
    ],
    providers:[
        TemplateApiService,
        TemplateService
    ],
    declarations: []
})
export class TemplatesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/templates/templates.module.ts
 **/